import GsapScroll from './gsap-scroll.js';
import SmoothScroll from '../SmoothScroll.js';
import Buttons from './Buttons.js';

const initComponents = function($ = jQuery) {

  // ===================
  // Init Components
  const components = [
    GsapScroll,
    SmoothScroll,
    Buttons,
  ];

  $(components).each(function(index, component) {
    component.init();
  });

};

export { initComponents };